import script from "./ProgramForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramForm.vue?vue&type=script&setup=true&lang=js"

import "./ProgramForm.vue?vue&type=style&index=0&id=5f8bf510&lang=scss"

const __exports__ = script;

export default __exports__